// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIrsLimitDto } from './IIrsLimitDto';
import {
    IIrsLimitDtoFromJSON,
    IIrsLimitDtoFromJSONTyped,
    IIrsLimitDtoToJSON,
    IIrsLimitDtoToJSONTyped,
} from './IIrsLimitDto';

/**
 * 
 * @export
 * @interface IPolicyLimitsDto
 */
export interface IPolicyLimitsDto {
    /**
     * 
     * @type {number}
     * @memberof IPolicyLimitsDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyLimitsDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyLimitsDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPolicyLimitsDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IPolicyLimitsDto
     */
    contribution_limit_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyLimitsDto
     */
    election_policy_limit_amount?: number;
    /**
     * 
     * @type {IIrsLimitDto}
     * @memberof IPolicyLimitsDto
     */
    irs_limit?: IIrsLimitDto;
}

/**
 * Check if a given object implements the IPolicyLimitsDto interface.
 */
export function instanceOfIPolicyLimitsDto(value: object): value is IPolicyLimitsDto {
    return true;
}

export function IPolicyLimitsDtoFromJSON(json: any): IPolicyLimitsDto {
    return IPolicyLimitsDtoFromJSONTyped(json, false);
}

export function IPolicyLimitsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicyLimitsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'contribution_limit_amount': json['contribution_limit_amount'] == null ? undefined : json['contribution_limit_amount'],
        'election_policy_limit_amount': json['election_policy_limit_amount'] == null ? undefined : json['election_policy_limit_amount'],
        'irs_limit': json['irs_limit'] == null ? undefined : IIrsLimitDtoFromJSON(json['irs_limit']),
    };
}

export function IPolicyLimitsDtoToJSON(json: any): IPolicyLimitsDto {
    return IPolicyLimitsDtoToJSONTyped(json, false);
}

export function IPolicyLimitsDtoToJSONTyped(value?: IPolicyLimitsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'account_id': value['account_id'],
        'plan_id': value['plan_id'],
        'plan_code': value['plan_code'],
        'contribution_limit_amount': value['contribution_limit_amount'],
        'election_policy_limit_amount': value['election_policy_limit_amount'],
        'irs_limit': IIrsLimitDtoToJSON(value['irs_limit']),
    };
}

